export function formatDateAndHours(
  dateString: any,
  format: string = "default"
) {
  if (!dateString) return format === "default" ? { date: "-", time: "-" } : "-";

  const date = new Date(dateString);

  // Convert to IST by getting UTC time and adding 5:30
  const utcHours = date.getUTCHours();
  const utcMinutes = date.getUTCMinutes();

  // Calculate IST time correctly
  let istHours = utcHours + 5;
  let istMinutes = utcMinutes + 30;

  // Handle minute overflow
  if (istMinutes >= 60) {
    istHours += 1;
    istMinutes -= 60;
  }

  // Handle hour overflow
  istHours = istHours % 24;

  const day = date.getUTCDate();
  const month = date.toLocaleString("en-US", {
    month: "long",
    timeZone: "UTC",
  });
  const year = date.getUTCFullYear();

  const daySuffix = getDaySuffix(day);

  const ampm = istHours >= 12 ? "PM" : "AM";
  const formattedHour = istHours % 12 === 0 ? "12" : (istHours % 12).toString();
  const formattedMinute =
    istMinutes < 10 ? `0${istMinutes}` : istMinutes.toString();

  const formattedDate = `${day}${daySuffix} ${month} ${year}`;
  const formattedTime = `${formattedHour}:${formattedMinute} ${ampm}`;

  if (format === "date") {
    return formattedDate;
  } else if (format === "time") {
    return formattedTime;
  } else {
    return { date: formattedDate, time: formattedTime };
  }
}

function getDaySuffix(day: any) {
  if (day >= 11 && day <= 13) {
    return "th";
  }
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}
